
      import Building from './building.vue'
      import type { App, Plugin } from 'vue'

      export const BuildingPlugin: Plugin = {
        install(app: App) {
          app.component('Building', Building)
        },
      }
      export { Building }
      